import { FC, useEffect, useState } from 'react';
import cls from 'classnames';
import { useSwiper, SwiperClass } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { $DOMReadyState } from '@lemon8/web-app-shared/atom';
import { EPageModule } from '~/utils/page-module';
import { EClickPosition } from '~/utils/click-position';

import './style.scss';

export const NextPageTip: FC = () => {
  const [tipsState, setTipsState] = useState('');
  const swiper = useSwiper();
  const { t } = useTranslation();
  const domReadyState = useAtomValue($DOMReadyState);

  useEffect(() => {
    if (domReadyState === 'complete') {
      setTipsState('show');
    }
  }, [domReadyState]);

  useEffect(() => {
    const handleSlideChange = (swiper: SwiperClass): void => {
      if (swiper.activeIndex === 0) {
        setTipsState('show');
      } else {
        setTipsState('hide');
      }
    };

    swiper.on('slideChange', handleSlideChange);

    return () => {
      swiper.off('slideChange', handleSlideChange);
    };
  }, [swiper]);

  const handleClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: EPageModule.OVERALL_INTRO,
      current_position: EClickPosition.VIEW_MORE_FEATURES,
      is_cta: 0,
    });
    swiper.slideTo(1);
  };

  return (
    <div
      className={cls(`next-slide-arrow-wrap`, { show: tipsState === 'show', hide: tipsState === 'hide' })}
      onClick={handleClick}
    >
      <div className="Layer-static" />
      <div className="Layer-wrap">
        <div className="Layer-4">
          <div className="Layer-4-opacity">
            <div className="Layer-4-content"></div>
          </div>
        </div>
        <div className="Layer-3">
          <div className="Layer-3-opacity">
            <div className="Layer-3-content"></div>
          </div>
        </div>
        <div className="Layer-2">
          <div className="Layer-2-opacity">
            <div className="Layer-2-content"></div>
          </div>
        </div>
        <div className="Layer-1">
          <div className="Layer-1-opacity">
            <div className="Layer-1-content"></div>
          </div>
        </div>
      </div>
      <div className="text">{t('official_website_viewMore_btn')}</div>
    </div>
  );
};
